<template>
  <div>
    <v-btn
      v-if="!isEdit"
      color="green"
      class="mt-3"
      icon
      x-large
      @click="dialog = true"
      ><v-icon>mdi-plus-box</v-icon></v-btn
    >
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <ModalHeader
          title="Add Supplier Data"
          icon="mdi-account"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <v-text-field
            outlined
            dense
            label="Supplier Name"
            v-model="form.supplier_name"
            prepend-icon="mdi-domain"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="Batch Prefix (e.g. UM for UMAL)"
            v-model="form.batch_prefix"
            prepend-icon="mdi-tag"
            hint="Used to auto-generate batch tags like UM-22-C"
            persistent-hint
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="Contact Person"
            prepend-icon="mdi-account-tie"
            v-model="form.contact_person"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="Supplier Contact"
            v-model="form.supplier_contact_no"
            prepend-icon="mdi-phone"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="Contact Platform"
            v-model="form.contact_platform"
            prepend-icon="mdi-cellphone-message"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="Supplier Address"
            v-model="form.supplier_address"
            prepend-icon="mdi-map-marker"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            prepend-icon="mdi-percent"
            label="Vat Percentage"
            v-model="form.vat_percentage"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            prepend-icon="mdi-cart"
            label="Item Sales"
            v-model="form.item_sales"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            prepend-icon="mdi-bank"
            label="Bank Account #"
            v-model="form.bank_account_number"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            prepend-icon="mdi-account"
            label="Bank Account Name"
            v-model="form.bank_account_name"
          ></v-text-field>
          <v-select
            outlined
            dense
            prepend-icon="mdi-cash"
            label="Payment Method"
            v-model="form.payment_method"
            :items="paymentMethods"
            clearable
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="submit" color="primary" :loading="loading">Add</v-btn>
          <v-btn @click="dialog = false"> Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["isEdit"],
  data() {
    return {
      loading: false,
      dialog: false,
      paymentMethods: ["FundTransfer", "Gcash", "Cash on Delivery"],
      form: {
        supplier_name: "",
        batch_prefix: "",
        supplier_contact_no: "",
        supplier_address: "",
        bank_account_number: "",
        bank_account_name: "",
        payment_method: "",
      },
    };
  },
  methods: {
    ...mapActions({
      add_supplier: "supplier/add_supplier",
    }),
    async submit() {
      this.loading = true;
      try {
        await this.add_supplier(this.form);
        this.$alert({
          title: "Success",
          message: "You have successfully added a new supplier!",
          color: "success",
          icon: "mdi-check-circle",
        });
        this.dialog = false;
        this.resetForm();
        this.$emit("success");
      } catch (error) {
        console.error("Error adding supplier:", error);
        this.$alert({
          title: "Error",
          message: "Failed to add supplier. Please try again.",
          color: "error",
          icon: "mdi-alert-circle",
        });
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.form = {
        supplier_name: "",
        batch_prefix: "",
        supplier_contact_no: "",
        supplier_address: "",
        contact_person: "",
        contact_platform: "",
        vat_percentage: "",
        item_sales: "",
        bank_account_number: "",
        bank_account_name: "",
        payment_method: "",
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
